import { React, useRef, useState } from 'react';
import styled from 'styled-components';

import StatisticsView from './StatisticsView';
import SecondUserAuthenticationView from './SecondUserAuthenticationView';

function TotalStatisticsView() {
  const [isPassAuthorization, setIsPassAuthorization] = useState(false);

  const AuthRef = useRef();
  const StatisticsRef = useRef();

  // 2차 비밀번호 인증 성공 시 //
  function SuccessFn() {
    setIsPassAuthorization(true);
  }

  return (
    <TopLevelWrapper>
      {
        !isPassAuthorization &&
        <SecondUserAuthenticationView
          ref={AuthRef}
          clickFn={SuccessFn} />
      }
      {
        isPassAuthorization &&
        <StatisticsView ref={StatisticsRef} />
      }
    </TopLevelWrapper>
  )
}

export default TotalStatisticsView;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  margin-left: 10px;
`;
